var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 11.797l1.836-8.125c.117-.586-.313-1.172-.938-1.172H6.211L5.859.781C5.742.351 5.352 0 4.922 0H.938A.925.925 0 000 .938v.625c0 .546.39.937.938.937h2.695l2.773 13.438a2.183 2.183 0 00-1.093 1.874C5.313 19.023 6.288 20 7.5 20c1.172 0 2.188-.977 2.188-2.188 0-.585-.274-1.132-.665-1.562h8.165c-.391.43-.625.977-.625 1.563 0 1.21.976 2.187 2.187 2.187 1.172 0 2.188-.977 2.188-2.188 0-.859-.508-1.601-1.25-1.953l.195-.937c.156-.586-.313-1.172-.899-1.172H8.516l-.274-1.25h11.445c.43 0 .82-.273.938-.703z",
    fill: "#1B130E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.93455fc43a3c4c800f7b60c3789b9b91.svg";
export { ForwardRef as ReactComponent };